import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { toast } from 'sonner';

const WorkerReportETA = () => {
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [formData, setFormData] = useState({
    project_id: '',
    employee_id: '',
    date: new Date().toISOString().split('T')[0],
    title: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [projectsRes, employeesRes] = await Promise.all([
        api.getProjects(),
        api.getEmployees(),
      ]);
      setProjects(projectsRes.data.filter(p => p.status === 'active'));
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.createETAReport(formData);
      toast.success('ÄTA-rapport skickad!');
      setFormData({
        project_id: '',
        employee_id: '',
        date: new Date().toISOString().split('T')[0],
        title: '',
        description: '',
      });
    } catch (error) {
      console.error('Failed to submit ETA:', error);
      toast.error('Kunde inte skicka ÄTA-rapport');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6" data-testid="worker-report-eta-page">
      <div className="bg-card rounded-xl shadow-sm border border-border p-6 max-w-2xl mx-auto">
        <h2 className="text-xl font-semibold text-foreground mb-6" style={{ fontFamily: 'Work Sans' }}>Rapportera ÄTA</h2>
        
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label>Projekt *</Label>
            <Select value={formData.project_id} onValueChange={(value) => setFormData({ ...formData, project_id: value })}>
              <SelectTrigger data-testid="select-project-eta">
                <SelectValue placeholder="Välj projekt" />
              </SelectTrigger>
              <SelectContent>
                {projects.map(p => (
                  <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Anställd *</Label>
            <Select value={formData.employee_id} onValueChange={(value) => setFormData({ ...formData, employee_id: value })}>
              <SelectTrigger data-testid="select-employee-eta">
                <SelectValue placeholder="Välj anställd" />
              </SelectTrigger>
              <SelectContent>
                {employees.map(e => (
                  <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="date">Datum *</Label>
            <Input
              id="date"
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              data-testid="eta-date-input"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="title">Titel *</Label>
            <Input
              id="title"
              placeholder="Kort beskrivande titel"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              data-testid="eta-title-input"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="description">Beskrivning *</Label>
            <textarea
              id="description"
              className="w-full min-h-[120px] px-3 py-2 border border-border rounded-md"
              placeholder="Detaljerad beskrivning av ÄTA-arbetet"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              data-testid="eta-description-input"
              required
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="submit-eta-report-btn"
            className="w-full bg-orange-500 hover:bg-orange-600 py-6"
          >
            {loading ? 'Skickar...' : 'Skicka ÄTA-rapport'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default WorkerReportETA;
